import React, { Suspense } from "react";
import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
const BlankPage = React.lazy(() => import("../pages/blankPage"));
const LeadsDetails = React.lazy(() => import("../crm/leads/leadDetails"));
const Leads = React.lazy(() => import("../crm/leads/leads"));
const Login = React.lazy(() => import("../auth/login"));
const Register = React.lazy(() => import("../auth/register"));
const TwoStepVerification = React.lazy(
  () => import("../auth/twoStepVerification")
);
const EmailVerification = React.lazy(() => import("../auth/emailVerification"));
const ResetPassword = React.lazy(() => import("../auth/resetPassword"));
const ForgotPassword = React.lazy(() => import("../auth/forgotPassword"));
const Error404 = React.lazy(() => import("../pages/error/error-404"));
const Error500 = React.lazy(() => import("../pages/error/error-500"));
const UnderMaintenance = React.lazy(() => import("../pages/underMaintenance"));
const LeadsDashboard = React.lazy(() => import("../mainMenu/leadsDashboard"));
const Chat = React.lazy(() => import("../application/chat"));
const LostReason = React.lazy(() => import("../crmSetting/lostReason"));
const Permission = React.lazy(
  () => import("../userManagement/userRolePermission/permission")
);
const Institutions = React.lazy(
  () => import("../administration/institution/institution")
);
const InstitutionDetails = React.lazy(
  () => import("../administration/institution/institutionsDetails")
);
const Courses = React.lazy(() => import("../administration/courses/courses"));
const Roles = React.lazy(() => import("../userManagement/manageRole/roles"));
const Users = React.lazy(() => import("../userManagement/manageUser/users"));
const FollowUpComments = React.lazy(
  () => import("../crmSetting/FollowUpComments")
);
const EditBusiness = React.lazy(
  () => import("../businessDetails/EditbusinessDetails")
);
const Attendance = React.lazy(
  () => import("../administration/attendance/attendance")
);
const LeadResult = React.lazy(
  () => import("../administration/leadResult/leadResult")
);
const Invoices = React.lazy(
  () => import("../administration/invoices/invoices")
);

const route = all_routes;

export const publicRoutes = [
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/login" />,
    route: Route,
    title: "Login",
  },
  {
    path: route.dashboard,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <LeadsDashboard />
      </Suspense>
    ),
    route: Route,
    title: "Dashboard",
  },
  {
    path: route.institution,
    element: (
      <Suspense fallback={<div className="text-center">Loading...</div>}>
        <Institutions />
      </Suspense>
    ),
    route: Route,
    title: "Institution",
  },
  {
    path: `${route.institutionDetails}/:id`,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <InstitutionDetails />
      </Suspense>
    ),
    route: Route,
    title: "InstitutionDetails",
  },
  {
    path: route.course,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Courses />
      </Suspense>
    ),
    route: Route,
    title: "Course",
  },
  {
    path: route.attendance,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Attendance />
      </Suspense>
    ),
    route: Route,
    title: "Attendance",
  },
  {
    path: route.leadOutcome,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <LeadResult />
      </Suspense>
    ),
    route: Route,
    title: "LeadOutcome",
  },
  {
    path: route.invoice,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Invoices />
      </Suspense>
    ),
    route: Route,
    title: "Invoice",
  },

  {
    path: route.blankPage,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <BlankPage />
      </Suspense>
    ),
    route: Route,
    title: "Blank Page",
  },
  {
    path: route.user,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Users />
      </Suspense>
    ),
    route: Route,
    title: "User",
  },
  {
    path: `${route.LeadDetails}/:id`,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <LeadsDetails />
      </Suspense>
    ),
    route: Route,
    title: "LeadDetails",
  },
  {
    path: route.leads,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Leads />
      </Suspense>
    ),
    route: Route,
    title: "Lead",
  },
  {
    path: route.chat,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Chat />
      </Suspense>
    ),
    route: Route,
    title: "Chat",
  },

  {
    path: route.followUpComment,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <FollowUpComments />
      </Suspense>
    ),
    route: Route,
    title: "FollowUpComment",
  },

  {
    path: route.role,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Roles />
      </Suspense>
    ),
    route: Route,
    title: "Role",
  },

  {
    path: route.lostReason,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <LostReason />
      </Suspense>
    ),
    route: Route,
    title: "LostReason",
  },
  {
    path: `${route.userPermission}/:id`,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Permission />
      </Suspense>
    ),
    route: Route,
    title: "userPermission",
  },
  {
    path: route.business,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <EditBusiness />
      </Suspense>
    ),
    route: Route,
    title: "Business",
  },
];

export const authRoutes = [
  {
    path: route.login,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Login />
      </Suspense>
    ),
    route: Route,
    title: "Login",
  },
  {
    path: route.register,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Register />
      </Suspense>
    ),
    route: Route,
    title: "Register",
  },
  {
    path: route.twoStepVerification,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <TwoStepVerification />
      </Suspense>
    ),
    route: Route,
    title: "TwoStepVerification",
  },
  {
    path: route.emailVerification,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <EmailVerification />
      </Suspense>
    ),
    route: Route,
    title: "EmailVerification",
  },
  {
    path: route.resetPassword,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <ResetPassword />
      </Suspense>
    ),
    route: Route,
    title: "Reset Password",
  },
  {
    path: route.forgotPassword,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <ForgotPassword />
      </Suspense>
    ),
    route: Route,
    title: "Forgot Password",
  },
  {
    path: route.error404,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Error404 />
      </Suspense>
    ),
    route: Route,
    title: "Error404",
  },
  {
    path: route.error500,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Error500 />
      </Suspense>
    ),
    route: Route,
    title: "Error500",
  },
  {
    path: route.underMaintenance,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <UnderMaintenance />
      </Suspense>
    ),
    route: Route,
    title: "Under Maintenance",
  },
];
